<script setup lang="ts">
import TagsModule from "./TagsModule.vue"
import { ref, defineProps, toRef, watch } from "vue"
import { graphql } from "~/utils/graphql"

const props = defineProps<{
  currentMoods: string[]
  trackId: string
}>()

const moods = toRef(props, "currentMoods")
const localMoods = ref<string[]>([...moods.value])

watch(moods, newValue => {
  localMoods.value = [...newValue]
})

async function onUpdate(newMoods: string[]) {
  localMoods.value = newMoods

  await graphql(
    `
    mutation SaveMoods($trackId: ID!, $moods: [String!]!) {
      setTrackMoods(trackID: $trackId, moods: $moods) {
        id
        moods
      }
    }
  `,
    { trackId: props.trackId, moods: newMoods }
  )
}
</script>

<template>
  <TagsModule label="Moods" :tags="localMoods" :track-id="trackId" @update="onUpdate" />
</template>
